/**
 * The Supabase project, as the browser is allowed to know it — FCS-056.
 * ============================================================================
 * These two values are PUBLIC and committed on purpose.
 *
 * The project URL is public by definition, and a key with the
 * `sb_publishable_` prefix is built to be shipped to browsers — it is the
 * anonymous identity every visitor already uses. What stops a stranger
 * reading somebody else's row is RLS on the table, not the obscurity of this
 * string, and treating it as a secret buys nothing while costing a great
 * deal: anything read through `process.env.GATSBY_*` is compiled into the
 * bundle at BUILD time, so a deploy that lacks the variable ships a site
 * where nobody can log in at all — which is exactly what happened here. The
 * live pages said "Accounts are not set up on this environment" because the
 * Pages build had no .env, and putting the value in a GitHub secret would not
 * have hidden it either: it lands in the JavaScript either way.
 *
 * ── WHAT MUST NEVER GO IN THIS FILE ────────────────────────────────────────
 * Anything with the `sb_secret_` prefix (the service-role key), any Stripe
 * secret or webhook signing secret, the Resend key, the admin token. Those
 * belong in Edge Function secrets and on the server, and scripts/check-
 * secrets.js fails the build if one of them turns up here or anywhere else in
 * the bundle.
 *
 * The environment still wins where it is set, so a second deployment can
 * point at its own project without editing this file.
 */

export const SUPABASE_URL =
  process.env.GATSBY_SUPABASE_URL || "https://aalxuddgvefcogevoqmv.supabase.co"

export const SUPABASE_PUBLISHABLE_KEY =
  process.env.GATSBY_SUPABASE_PUBLISHABLE_KEY || "sb_publishable_1UVqX73WNxZu-wwGbLVKUw_fpnxAvAw"
